/**
 * A collection of texts that may repeatedly used on the site 
 */

export const applicationSuccess = "Your application was sent successfully. You will receive feedback via email. Please check your inbox for a message letting you know of the outcome of your application. If you have not received a message within 5 working days, and there is nothing in your spam folder, please email admin@supernovafoundation.org";
